import { makeAutoObservable } from 'mobx'

import { restClient } from '@/Core'
import { parseApiErrorDescription } from '@/Ship/Helpers/parseApiError'

import type { Notify } from '@/Ship/Contracts/Notify'

/**
 * Local store of `CreateTypicalRouteModal`.
 * Owns the new typical-route form fields, submission flag, and the create request.
 * loadingPoint/unloadingPoint are pinned to the assignment card's current points
 * (passed into `create`, not editable in the modal) — the point pair is what the
 * dropdown is already filtered by, so the new route must match it.
 * Instantiated per modal mount via `useState(() => new CreateTypicalRouteModalStore())`.
 */
export class CreateTypicalRouteModalStore {
    title = ''
    routeUrl = ''
    priority = 0
    loading = false

    constructor() {
        makeAutoObservable(this)
    }

    setTitle(v: string): void {
        this.title = v
    }

    setRouteUrl(v: string): void {
        this.routeUrl = v
    }

    setPriority(v: number): void {
        this.priority = v
    }

    setLoading(v: boolean): void {
        this.loading = v
    }

    reset(): void {
        this.title = ''
        this.routeUrl = ''
        this.priority = 0
    }

    async create(loadingPointIri: string, unloadingPointIri: string, notify: Notify): Promise<any | null> {
        if (!this.title.trim()) {
            notify.error('Вкажіть назву маршруту')
            return null
        }
        this.setLoading(true)
        try {
            const route = await restClient.post('/services/typical-routes', {
                json: {
                    title: this.title.trim(),
                    loadingPoint: loadingPointIri,
                    unloadingPoint: unloadingPointIri,
                    routeUrl: this.routeUrl.trim() || null,
                    priority: this.priority || 0,
                },
            })
            notify.success('Типовий маршрут створено')
            this.reset()
            return route
        } catch (err) {
            notify.error(await parseApiErrorDescription(err, 'Помилка створення типового маршруту'))
            return null
        } finally {
            this.setLoading(false)
        }
    }
}
